import { TOAuthState } from "src/shared/types/globalStotre.types";
import { useSeatGeek } from "src/components/reusable/hooks/useSeatGeek";
import { useTicketsdotcom } from "src/components/reusable/hooks/useTicketsdotcom";
import { useTicketmaster } from "src/components/reusable/hooks/useTicketmaster";
import { useTeamConfig } from "../components/TeamConfigProvider";
import { constants } from "src/shared/constants";

export function useVendorAuth() {
  const teamConfig = useTeamConfig();
  const { connectSeatGeek } = useSeatGeek();
  const { connectTicketsdotcom } = useTicketsdotcom();
  const { connectTicketmaster } = useTicketmaster();

  const loginWithVendor = async (state: TOAuthState) => {
    if (teamConfig.VENDOR === constants.vendorUUIDs.seatgeek) {
      return await connectSeatGeek(state);
    }
    if (teamConfig.VENDOR === constants.vendorUUIDs.ticketsdotcom) {
      return await connectTicketsdotcom(state);
    }
    return await connectTicketmaster({ state });
  };

  return {
    loginWithVendor,
  };
}
